<template>
  <v-autocomplete
    :items="items"
    v-model="selectedFilter"
    :label="label"
    multiple
    clearable
    @blur="emitChange"
    @click.clear="emitChange"
  >
    <template v-slot:prepend-item>
      <v-list-item
        ripple
        @click="toggle"
      >
        <v-list-item-action>
          <v-icon :color="filter.length > 0 ? 'indigo darken-4' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Select All
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
  export default {
    props : ['items', 'filter', 'cat', 'criteriaFilter'],
    data(){
      return {
        //cats : ['bidder','custadunit','device','invtype','inventory'],
        loading: false,
        selectedFilter : []
      }
    },
    created(){
    },
    watch: {
      criteriaFilter(){
        this.selectedFilter.push(this.criteriaFilter)
      }
    },
    methods: {
      emitChange(){
        this.$emit('filterUpdate',{
          cat: this.cat,
          filter: this.selectedFilter
        })
      },
      toggle () {
        this.$nextTick(() => {
          if (this.likesAll) {
            this.selectedFilter = []
          } else {
            this.selectedFilter = this.items.map(item => item.value)
          }
        })
      },
    },
    computed:{
      likesAll(){
        return this.items == undefined ? false : this.selectedFilter.length === this.items.length
      },
      likesSome(){
        return this.selectedFilter.length > 0 && !this.likesAll
      },
      icon () {
        if (this.likesAll) return 'mdi-close-box'
        if (this.likesSome) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      label(){
        return this.cat.charAt(0).toUpperCase() + this.cat.slice(1)
      }
    },
    
  } 
</script>